import { Spinner as ChakraSpinner } from "@chakra-ui/react";
import { EXTENDED_TSHIRT_SIZING, SpinnerSharedProps } from "./Spinner.props";

export const Spinner = ({
  color = "primary.800",
  thickness: _thickness,
  speed: _speed,
  size: rawSize,
  ...rest
}: SpinnerSharedProps) => {
  let boxSize: string | undefined;
  const inputSize = rawSize ?? "md";

  const chakraSpinnerSizes = ["xs", "sm", "md", "lg", "xl", "inherit"] as const;
  type KnownSize = (typeof chakraSpinnerSizes)[number];

  let size: KnownSize | undefined = (
    chakraSpinnerSizes as readonly string[]
  ).includes(inputSize)
    ? (inputSize as KnownSize)
    : undefined;

  // Chakra's spinner does not allow pixel sized spinners. Putting this as a safety net.
  if (inputSize.endsWith("px")) {
    boxSize = inputSize;
    size = undefined;
  }

  if (inputSize in EXTENDED_TSHIRT_SIZING) {
    boxSize =
      EXTENDED_TSHIRT_SIZING[inputSize as keyof typeof EXTENDED_TSHIRT_SIZING];
    size = undefined;
  }

  return (
    <ChakraSpinner size={size} boxSize={boxSize} color={color} {...rest} />
  );
};

export type { SpinnerSharedProps as SpinnerProps } from "./Spinner.props";
export { EXTENDED_TSHIRT_SIZING } from "./Spinner.props";
